import { Injectable } from '@angular/core';
import { type Attributes } from '@opentelemetry/api';

import {
  recordError,
  recordEvent,
  recordLog,
  setTelemetryUser,
  SeverityNumber,
  type TelemetryUser,
} from './telemetry-api';

/**
 * Façade injectable de télémétrie pour l'app Angular (interceptors, ErrorHandler,
 * services métier). Délègue à la couche légère `telemetry-api` — donc inerte
 * tant que le SDK n'est pas initialisé (dev) ou si la télémétrie est désactivée.
 */
@Injectable({ providedIn: 'root' })
export class TelemetryService {
  /** Enregistre une erreur (→ Loki, conventions exception.*). */
  error(error: unknown, attributes?: Attributes): void {
    recordError(error, attributes);
  }

  /** Log informationnel structuré (→ Loki). */
  info(message: string, attributes?: Attributes): void {
    recordLog(SeverityNumber.INFO, message, attributes);
  }

  /** Log d'avertissement structuré (→ Loki). */
  warn(message: string, attributes?: Attributes): void {
    recordLog(SeverityNumber.WARN, message, attributes);
  }

  /** Évènement applicatif nommé (→ Loki). */
  event(name: string, attributes?: Attributes): void {
    recordEvent(name, attributes);
  }

  /** Associe l'utilisateur courant à la télémétrie (id + rôles, aucune PII). */
  setUser(user: TelemetryUser | null): void {
    setTelemetryUser(user);
  }
}
